import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Instagram, Linkedin, Youtube, Link2, Award } from 'lucide-react';
import { company, navLinks, destinations, waLink } from '../mock';

export default function Footer() {
  const socials = [
    { Icon: Instagram, url: company.socials.instagram, label: 'Instagram' },
    { Icon: Facebook, url: company.socials.facebook, label: 'Facebook' },
    { Icon: Linkedin, url: company.socials.linkedin, label: 'LinkedIn' },
    { Icon: Youtube, url: company.socials.youtube, label: 'YouTube' },
    { Icon: Link2, url: company.socials.linktree, label: 'Linktree' },
  ];
  return (
    <footer className="bg-[#071a33] text-white/80">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="bg-white rounded-xl p-3 inline-block">
            <img src={company.logo} alt={company.name} className="h-12 w-auto" />
          </div>
          <p className="mt-5 text-sm leading-relaxed text-white/60 max-w-xs">
            Handcrafted journeys designed around the way you love to travel. Explore the world with confidence.
          </p>
          <div className="mt-6 flex gap-3">
            {socials.map(({ Icon, url, label }) => (
              <a key={label} href={url} target="_blank" rel="noreferrer" aria-label={label} className="grid place-items-center h-10 w-10 rounded-full bg-white/10 hover:bg-[#EA5019] transition-colors">
                <Icon size={18} className="text-white" />
              </a>
            ))}
          </div>

          <div className="mt-7">
            <p className="text-white/50 text-xs uppercase tracking-wider font-semibold mb-3">Certifications & Memberships</p>
            <div className="flex flex-wrap gap-2">
              {[
                'Australia Aussie Specialist',
                'Certified South African Specialist',
                'Spain 360 Expert',
                '100% Pure New Zealand Specialist',
                'Switzerland Tourism Member',
              ].map((c) => (
                <span key={c} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/[0.06] border border-white/10 text-[11px] font-medium text-white/80">
                  <Award size={12} className="text-[#ff7a45]" /> {c}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div>
          <h4 className="font-heading text-white font-bold mb-5">Quick Links</h4>
          <ul className="space-y-3 text-sm">
            {navLinks.map((l) => (
              <li key={l.label}><a href={l.href} className="hover:text-[#ff7a45] transition-colors">{l.label}</a></li>
            ))}
            <li><Link to="/estimator" className="hover:text-[#ff7a45] transition-colors">Trip Estimator</Link></li>
            <li><Link to="/terms" className="hover:text-[#ff7a45] transition-colors">Terms & Conditions</Link></li>
            <li><Link to="/terms#account" className="hover:text-[#ff7a45] transition-colors">Account Details</Link></li>
            <li><Link to="/terms#pay" className="hover:text-[#ff7a45] transition-colors">Pay Advance Online</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-white font-bold mb-5">Top Destinations</h4>
          <ul className="space-y-3 text-sm">
            {destinations.slice(0, 6).map((d) => (
              <li key={d.name}><a href="#destinations" className="hover:text-[#ff7a45] transition-colors">{d.name}</a></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-white font-bold mb-5">Contact</h4>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3"><MapPin size={18} className="text-[#EA5019] shrink-0 mt-0.5" /> <span><span className="block text-white/50 text-xs uppercase tracking-wider mb-0.5">Registered Office</span>{company.registeredOffice}</span></li>
            <li className="flex items-start gap-3"><MapPin size={18} className="text-[#EA5019] shrink-0 mt-0.5" /> <span><span className="block text-white/50 text-xs uppercase tracking-wider mb-0.5">Secondary Office</span>{company.secondaryOffice}</span></li>
            <li className="flex items-center gap-3"><Phone size={18} className="text-[#EA5019] shrink-0" /> {company.phone}</li>
            <li className="flex items-center gap-3"><Mail size={18} className="text-[#EA5019] shrink-0" /> {company.email}</li>
          </ul>
          <a href={waLink} target="_blank" rel="noreferrer" className="mt-6 inline-block px-5 py-2.5 rounded-full bg-[#EA5019] text-white text-sm font-semibold hover:bg-[#cf4413] transition-colors">Get a Free Quote</a>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-white/50">
          <p>{"\u00A9"} {new Date().getFullYear()} {company.name}. All rights reserved.</p>
          <p>Designed for extraordinary journeys.</p>
        </div>
      </div>
    </footer>
  );
}
